module.exports = __webpack_public_path__ + "img/format_italic.2424be4a.svg";